import React, { useState, useEffect } from "react";
import { useLockViewportScroll } from "../../hook/useLockViewportScroll";
import {
  REGISTRATION_STEP_TITLE_PROPS,
  useRegistrationStepFocus,
} from "../../hook/useRegistrationStepFocus";
import RegisterWrapper from "./Register.style";
import { withRouter } from "react-router-dom";
import { connect } from "react-redux";
import { compose } from "redux";
import LogRocket from "logrocket";
import enhancer, {
  normalizeRegisterDobDisplayValue,
  resolveRegisterValidationMessage,
} from "./Register.validator";
import AuthenticationApiSerivce from "../../api/AuthServices";
import AuthActions from "../../redux/auth/actions";
import { message } from "antd";
import { Loader } from "../../icons";
import { useTranslation } from "react-i18next";
import clsx from "clsx";
import { RegistrationLayout } from "../RegistrationLayout/RegistrationLayout";
import RegistrationDobField from "../RegistrationLayout/RegistrationDobField";
import { RegistrationSetupNavbar } from "../RegistrationLayout/RegistrationSetupNavbar";
import {
  focusFirstInvalidRegistrationField,
  getRegistrationFieldControlProps,
  getRegistrationFieldErrorId,
  isRegistrationFieldInvalid,
  RegistrationContinueArrow,
  RegistrationFieldError,
  RegistrationSelectedCheck,
} from "../RegistrationLayout/RegistrationFieldError";
import { RegistrationRequiredMark } from "../RegistrationLayout/RegistrationA11y";
import { getRovingTabIndex } from "../RegistrationLayout/registrationRovingTabIndex";
import {
  IS_LOG_ROCKET_ON,
  REGISTRATION_SETUP_STEP_META,
  REGISTRATION_SETUP_TOTAL_STEPS,
} from "../../helper/constants";
import {
  getRegistrationData,
  isRegistrationComplete,
  clearRegistrationData,
} from "../RegistrationSetup/registrationSetupStorage";
import {
  applyCheckEmailResumePrefill,
  buildCheckEmailAndCodePayload,
  canContinueFromEmailCodeCheck,
  getCheckEmailDisplayMessage,
  isCheckEmailCannotResume,
  isCheckEmailCompletedAccountNoResume,
  isCheckEmailNotFound,
  isCheckEmailResumeEligible,
  isCheckEmailSuccess,
  mapCheckEmailResponseToRegistrationData,
  mergePrefilledCategoryOptions,
  shouldShowProviderUnavailableScreen,
} from "../RegistrationSetup/registrationEmailResume";
import {
  goToNoProviderAvailableScreen,
  redirectIfProviderUnavailableBeforeApi,
  shouldGoToNoProviderScreen,
} from "../RegistrationSetup/registrationRdAvailability";
import { RESTORE_ACCOUNT_PASSWORD_STATE_KEY } from "../RegistrationSetup/registrationNavigation";
import {
  isRegistrationLoadRetryExhaustedError,
  isRequestCancelledError,
} from "../../api/requestRetry";
import { resolveUserSubmitErrorMessage } from "../../api/submitRequestErrors";
import {
  trackProviderAvailabilityChecked,
  trackRegistrationError,
  trackRegistrationStepBack,
  trackRegistrationStepCompleted,
} from "../../helper/registrationAnalytics";

const ACCOUNT_STEP = REGISTRATION_SETUP_STEP_META.ACCOUNT;

const ACCOUNT_FIELD_FOCUS_ORDER = [
  { field: "firstName", id: "firstName" },
  { field: "lastName", id: "lastName" },
  { field: "preferredName", id: "preferredName" },
  { field: "email", id: "email" },
  { field: "registrationCode", id: "registrationCode" },
  { field: "dob", id: "reg-dob" },
  { field: "zipCode", id: "reg-zip" },
  { field: "password", id: "reg-password" },
  { field: "confirmPassword", id: "reg-confirm-password" },
  {
    field: "categoryId",
    selector:
      '.knowledge-options [role="radio"][aria-checked="true"], .knowledge-options [role="radio"]',
  },
  { field: "acceptedTerms", id: "accepted-terms" },
];

const { login } = AuthActions;

const queryString = require("query-string");

const EMAIL_CHECK_DEBOUNCE_MS = 600;

const PasswordVisibilityIcon = ({ visible }) =>
  visible ? (
    <svg
      width="18"
      height="18"
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
      aria-hidden="true"
    >
      <path d="M1 12s4-8 11-8 11 8 11 8-4 8-11 8-11-8-11-8z" />
      <circle cx="12" cy="12" r="3" />
    </svg>
  ) : (
    <svg
      width="18"
      height="18"
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
      aria-hidden="true"
    >
      <path d="M17.94 17.94A10.07 10.07 0 0 1 12 20c-7 0-11-8-11-8a18.45 18.45 0 0 1 5.06-5.94" />
      <path d="M9.9 4.24A9.12 9.12 0 0 1 12 4c7 0 11 8 11 8a18.5 18.5 0 0 1-2.16 3.19" />
      <path d="M14.12 14.12a3 3 0 1 1-4.24-4.24" />
      <line x1="1" y1="1" x2="23" y2="23" />
    </svg>
  );

const isValidEmail = (email) =>
  /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email);

const mapCategoryListItem = (item, translate) => {
  const id = item?.id ?? item?.category_id;
  if (id == null) {
    return null;
  }

  const titleKey = item?.title ?? item?.name;
  const descriptionKey =
    item?.description ?? item?.subtitle ?? item?.info ?? item?.tooltip;

  return {
    id,
    title: titleKey ? translate(titleKey) : "",
    description: descriptionKey ? translate(descriptionKey) : "",
  };
};

const extractCategoryList = (res) => {
  if (Array.isArray(res?.data)) {
    return res.data;
  }
  if (Array.isArray(res?.data?.category_list)) {
    return res.data.category_list;
  }
  if (Array.isArray(res?.data?.list)) {
    return res.data.list;
  }
  return [];
};

const Register = (props) => {
  const { t, i18n } = useTranslation();
  const { login: loginAction } = props;
  const [codeLoading, setCodeLoading] = useState(false);
  const [emailCheckBlocked, setEmailCheckBlocked] = useState(false);
  const [emailCheckMessage, setEmailCheckMessage] = useState("");
  const [emailCheckMessageType, setEmailCheckMessageType] = useState("info");
  const [emailCheckComplete, setEmailCheckComplete] = useState(true);
  const [registrationCodeDisabled, setRegistrationCodeDisabled] = useState(false);
  const [whyBoxOpen, setWhyBoxOpen] = useState(false);
  const [knowledgeOptions, setKnowledgeOptions] = useState([]);
  const [categoriesLoading, setCategoriesLoading] = useState(true);
  const [showPassword, setShowPassword] = useState(false);
  const [showConfirmPassword, setShowConfirmPassword] = useState(false);
  const stepTitleRef = useRegistrationStepFocus();
  const {
    setFieldValue,
    setFieldTouched,
    setSubmitting,
    setTouched,
    values,
    handleChange,
    handleBlur,
    errors,
    touched,
    submitCount,
    isSubmitting,
    validateForm,
  } = props;

  useLockViewportScroll();

  useEffect(() => {
    const controller = new AbortController();
    let cancelled = false;

    setCategoriesLoading(true);
    AuthenticationApiSerivce.categoryList(i18n.language, {
      signal: controller.signal,
    })
      .then((res) => {
        if (cancelled) return;
        if (res?.status) {
          const mapped = extractCategoryList(res)
            .map((item) => mapCategoryListItem(item, t))
            .filter(Boolean);
          if (mapped.length > 0) {
            const savedSelectedCategories =
              getRegistrationData().selectedCategories ?? [];
            setKnowledgeOptions(
              mergePrefilledCategoryOptions(mapped, savedSelectedCategories)
            );
          }
        }
      })
      .catch((err) => {
        if (
          cancelled ||
          isRequestCancelledError(err) ||
          isRegistrationLoadRetryExhaustedError(err)
        ) {
          return;
        }
      })
      .finally(() => {
        if (!cancelled) {
          setCategoriesLoading(false);
        }
      });

    return () => {
      cancelled = true;
      controller.abort();
    };
  }, [i18n.language, t]);

  useEffect(() => {
    let shouldValidate = false;

    const queryCode = props.location.search
      ? queryString.parse(props.location.search).code
      : null;
    const hasQueryRegistrationCode =
      typeof queryCode === "string" && queryCode.trim().length > 0;

    if (hasQueryRegistrationCode) {
      setFieldValue("registrationCode", queryCode.trim().toUpperCase());
      setRegistrationCodeDisabled(true);
      shouldValidate = true;
    }

    const saved = localStorage.getItem("data");
    const shouldRestoreAccountPassword = Boolean(
      props.location?.state?.[RESTORE_ACCOUNT_PASSWORD_STATE_KEY]
    );
    if (saved) {
      try {
        const parsed = JSON.parse(saved);
        if (isRegistrationComplete(parsed)) {
          clearRegistrationData();
        } else {
        if (parsed.firstName) {
          setFieldValue("firstName", parsed.firstName);
          shouldValidate = true;
        }
        if (parsed.lastName) {
          setFieldValue("lastName", parsed.lastName);
          shouldValidate = true;
        }
        if (parsed.email) {
          setFieldValue("email", parsed.email);
          shouldValidate = true;
        }
        if (parsed.preferredName) {
          setFieldValue("preferredName", parsed.preferredName);
        }
        // Prefer ?code= from the URL over a stale localStorage value
        if (parsed.registrationCode && !hasQueryRegistrationCode) {
          setFieldValue("registrationCode", parsed.registrationCode);
          shouldValidate = true;
        }
        if (parsed.dob) {
          setFieldValue("dob", normalizeRegisterDobDisplayValue(parsed.dob));
          shouldValidate = true;
        }
        if (parsed.zipCode) {
          setFieldValue("zipCode", parsed.zipCode);
          shouldValidate = true;
        }
        if (parsed.categoryId) {
          setFieldValue("categoryId", parsed.categoryId);
          shouldValidate = true;
        }
        if (
          parsed.acceptedTerms === true ||
          parsed.isCheckedAcknowledgements === true
        ) {
          setFieldValue("acceptedTerms", true);
          shouldValidate = true;
        }
        if (parsed.selectedCategories?.length) {
          setKnowledgeOptions((current) =>
            mergePrefilledCategoryOptions(current, parsed.selectedCategories)
          );
        }
        if (shouldRestoreAccountPassword) {
          if (parsed.password) {
            setFieldValue("password", parsed.password);
            shouldValidate = true;
          }
          if (parsed.confirmPassword) {
            setFieldValue("confirmPassword", parsed.confirmPassword);
            shouldValidate = true;
          } else if (parsed.password) {
            setFieldValue("confirmPassword", parsed.password);
            shouldValidate = true;
          }
        }
        }
      } catch {
        // ignore invalid saved data
      }
    }

    if (shouldValidate) {
      validateForm();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useEffect(() => {
    const email = values.email.trim();
    setEmailCheckBlocked(false);
    setEmailCheckMessage("");

    if (!email || !isValidEmail(email)) {
      setEmailCheckComplete(true);
      return undefined;
    }

    setEmailCheckComplete(false);
    let cancelled = false;

    const timer = setTimeout(() => {
      AuthenticationApiSerivce.checkEmail({ email })
        .then((res) => {
          if (cancelled) return;

          if (isCheckEmailNotFound(res)) {
            setEmailCheckBlocked(false);
            setEmailCheckMessage("");
            return;
          }

          if (isCheckEmailCompletedAccountNoResume(res)) {
            const displayMessage = getCheckEmailDisplayMessage(
              res,
              t("NUTRITION_REGISTER_ERR_ACCOUNT_COMPLETED")
            );
            setEmailCheckBlocked(false);
            setEmailCheckMessage(displayMessage);
            setEmailCheckMessageType("info");
            message.info(displayMessage);
            return;
          }

          if (isCheckEmailCannotResume(res)) {
            const displayMessage = getCheckEmailDisplayMessage(
              res,
              t("NUTRITION_REGISTER_ERR_EMAIL_EXISTS")
            );
            setEmailCheckBlocked(false);
            setEmailCheckMessage(displayMessage);
            setEmailCheckMessageType("info");
            message.info(displayMessage);
            return;
          }

          if (isCheckEmailResumeEligible(res)) {
            const registrationData = applyCheckEmailResumePrefill({
              res,
              email,
              setFieldValue,
              validateForm,
              onRegistrationCodeLocked: setRegistrationCodeDisabled,
            });
            if (registrationData.selectedCategories?.length) {
              setKnowledgeOptions((current) =>
                mergePrefilledCategoryOptions(
                  current,
                  registrationData.selectedCategories
                )
              );
            }
            setEmailCheckBlocked(false);
            setEmailCheckMessage("");
            return;
          }

          setEmailCheckBlocked(false);
          setEmailCheckMessage("");
        })
        .catch(() => {
          if (!cancelled) {
            setEmailCheckMessage(
              resolveUserSubmitErrorMessage(null, {
                fallback: t("NUTRITION_REGISTER_ERR_VERIFY_EMAIL"),
                translate: t,
              })
            );
            setEmailCheckMessageType("error");
          }
        })
        .finally(() => {
          if (!cancelled) {
            setEmailCheckComplete(true);
          }
        });
    }, EMAIL_CHECK_DEBOUNCE_MS);

    return () => {
      cancelled = true;
      clearTimeout(timer);
    };
    // Only re-check when the email value changes; avoid clearing the message on unrelated re-renders.
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [values.email]);

  const showError = (field) => {
    if ((errors[field] && touched[field]) || submitCount > 0) {
      const key = errors[field];
      return (
        <RegistrationFieldError id={getRegistrationFieldErrorId(field)}>
          {resolveRegisterValidationMessage(key, t)}
        </RegistrationFieldError>
      );
    }
    return null;
  };

  const fieldControlProps = (field, className, extra = {}) =>
    getRegistrationFieldControlProps({
      field,
      errors,
      touched,
      submitCount,
      className,
      ...extra,
    });

  const emailCheckErrorId = "registration-field-error-email-check";
  const emailCheckInfoId = "registration-field-info-email-check";
  const emailHasCheckError = Boolean(
    emailCheckMessage && emailCheckMessageType === "error"
  );
  const emailHasCheckInfo = Boolean(
    emailCheckMessage && emailCheckMessageType === "info"
  );
  const emailControlProps = getRegistrationFieldControlProps({
    field: "email",
    errors,
    touched,
    submitCount,
    className: "form-input",
    required: true,
    describedBy: [
      emailHasCheckError ? emailCheckErrorId : null,
      emailHasCheckInfo ? emailCheckInfoId : null,
    ],
  });

  const isEmailCheckPending =
    !emailCheckComplete && isValidEmail(values.email.trim());

  const getCode = () => {
    setCodeLoading(true);
    AuthenticationApiSerivce.getRegistrationCode()
      .then((res) => {
        if (res.status) {
          setRegistrationCodeDisabled(true);
          setFieldValue("registrationCode", res.data.code);
        } else {
          message.error(res.message);
        }
        setCodeLoading(false);
      })
      .catch(() => {
        setCodeLoading(false);
        message.error(t("NUTRITION_COMMON_ERR_TRY_AGAIN"));
      });
  };

  const closeRegistrationCode = () => {
    setRegistrationCodeDisabled(false);
    setFieldValue("registrationCode", "");
  };

  const handleCategorySelect = (id) => {
    setFieldValue("categoryId", id, true);
    setFieldTouched("categoryId", true, false);
  };

  const handleCategoryKeyDown = (event) => {
    if (
      event.key !== "ArrowDown" &&
      event.key !== "ArrowUp" &&
      event.key !== "ArrowLeft" &&
      event.key !== "ArrowRight"
    ) {
      return;
    }
    const buttons = Array.from(
      event.currentTarget.querySelectorAll('[role="radio"]')
    );
    const currentIndex = buttons.indexOf(document.activeElement);
    if (currentIndex < 0 || buttons.length === 0) {
      return;
    }
    event.preventDefault();
    const delta =
      event.key === "ArrowDown" || event.key === "ArrowRight" ? 1 : -1;
    const nextIndex = (currentIndex + delta + buttons.length) % buttons.length;
    const nextId = knowledgeOptions[nextIndex]?.id;
    if (nextId != null) {
      handleCategorySelect(nextId);
    }
    buttons[nextIndex]?.focus();
  };

  const handleRegistrationCodeChange = (e) => {
    const upper = e.target.value.toUpperCase();
    setFieldValue("registrationCode", upper, true);
  };

  const handleZipCodeChange = (e) => {
    const digits = e.target.value.replace(/\D/g, "").slice(0, 5);
    setFieldValue("zipCode", digits, true);
  };

  const touchAllFields = () => {
    setTouched({
      firstName: true,
      lastName: true,
      preferredName: true,
      email: true,
      registrationCode: true,
      dob: true,
      zipCode: true,
      password: true,
      confirmPassword: true,
      categoryId: true,
      acceptedTerms: true,
    });
  };

  const onContinue = async (e) => {
    e.preventDefault();
    if (isEmailCheckPending) {
      return;
    }
    if (emailCheckBlocked) {
      message.error(
        emailCheckMessage || t("NUTRITION_REGISTER_ERR_EMAIL_EXISTS")
      );
      window.requestAnimationFrame(() => {
        document.getElementById("email")?.focus();
      });
      return;
    }

    touchAllFields();
    const formErrors = await validateForm();
    if (Object.keys(formErrors).length > 0) {
      trackRegistrationError({
        stepName: "account",
        stepNumber: 1,
        errorType: "validation_failed",
      });
      window.requestAnimationFrame(() => {
        focusFirstInvalidRegistrationField(ACCOUNT_FIELD_FOCUS_ORDER, formErrors);
      });
      return;
    }

    const emailCodeParams = buildCheckEmailAndCodePayload(values);

    // Persist form values so unavailable-state-lead can run if we redirect.
    localStorage.setItem(
      "data",
      JSON.stringify({
        ...getRegistrationData(),
        ...values,
        registrationCode: values.registrationCode.toUpperCase(),
      })
    );

    if (redirectIfProviderUnavailableBeforeApi(props.history, getRegistrationData())) {
      return;
    }

    setSubmitting(true);
    try {
      const emailCodeRes =
        await AuthenticationApiSerivce.checkEmailAndCode(emailCodeParams);

      const emailCodeData = emailCodeRes?.data ?? {};
      const resumeMappedData = mapCheckEmailResponseToRegistrationData(
        emailCodeRes,
        values.email
      );

      if (isCheckEmailSuccess(emailCodeRes)) {
        trackProviderAvailabilityChecked();
      }

      const baseSavedData = {
        ...getRegistrationData(),
        ...resumeMappedData,
        ...values,
        registrationCode: values.registrationCode.toUpperCase(),
        emailCodeCheck: emailCodeData,
        canResume: true,
        providerCode: !!emailCodeData?.is_provider_code,
        providerType: emailCodeData?.provider_type,
        categories: emailCodeData?.categories ?? [],
        ...(emailCodeData?.zipcode
          ? { zipCode: String(emailCodeData.zipcode).trim() }
          : {}),
        ...(emailCodeData?.state_id != null
          ? { stateId: emailCodeData.state_id }
          : {}),
        ...(emailCodeData?.state_name
          ? { stateName: emailCodeData.state_name }
          : {}),
        ...(emailCodeData?.state_code
          ? { stateCode: emailCodeData.state_code }
          : {}),
      };

      const applyEmailCodeLogin = () => {
        if (!emailCodeData?.access_token) {
          return;
        }

        loginAction({
          accessToken: emailCodeData.access_token,
          userId: emailCodeData?.user?.id,
          firstName: emailCodeData?.user?.first_name,
          lastName: emailCodeData?.user?.last_name,
          email: emailCodeData?.user?.email,
          isLogin: true,
          state: emailCodeData?.user?.state,
          insurance: emailCodeData?.user?.user_insurance?.insurance,
          isCardPresent: emailCodeData?.is_card_present || false,
        });
        if (IS_LOG_ROCKET_ON && emailCodeData?.id) {
          LogRocket.identify(emailCodeData.id, {
            name: `${emailCodeData?.user?.first_name} ${emailCodeData?.user?.last_name}`,
            email: emailCodeData?.email,
          });
        }
      };

      if (
        shouldGoToNoProviderScreen(emailCodeRes) ||
        shouldShowProviderUnavailableScreen(emailCodeRes)
      ) {
        applyEmailCodeLogin();
        localStorage.setItem("data", JSON.stringify(baseSavedData));
        trackRegistrationStepCompleted("account", 1);
        goToNoProviderAvailableScreen(props.history, emailCodeRes);
        return;
      }

      if (!canContinueFromEmailCodeCheck(emailCodeRes)) {
        message.info(
          getCheckEmailDisplayMessage(
            emailCodeRes,
            t("NUTRITION_REGISTER_ERR_CONTINUE")
          )
        );
        return;
      }

      applyEmailCodeLogin();

      localStorage.setItem("data", JSON.stringify(baseSavedData));
      trackRegistrationStepCompleted("account", 1);
      props.history.push("/register/account/payment");
    } catch (err) {
      trackRegistrationError({
        stepName: "account",
        stepNumber: 1,
        errorType: "api_failed",
      });
      message.error(
        resolveUserSubmitErrorMessage(err, {
          fallback: t("NUTRITION_COMMON_ERR_TRY_AGAIN"),
          translate: t,
        })
      );
    } finally {
      setSubmitting(false);
    }
  };

  return (
    <RegisterWrapper>
      <RegistrationLayout
        containScroll
        header={
          <RegistrationSetupNavbar
            stepMeta={ACCOUNT_STEP}
            totalSteps={REGISTRATION_SETUP_TOTAL_STEPS}
            onBack={() => {
              trackRegistrationStepBack("account");
              props.history.push("/register");
            }}
          />
        }
      >
        <div className="scroll-body">
          <div className="content-card">
            <form className="content-card-scroll" onSubmit={onContinue} noValidate>
              <div className="section-eyebrow">{t("NUTRITION_REGISTER_LBL_EYEBROW")}</div>
              <h2
                className="section-title"
                ref={stepTitleRef}
                {...REGISTRATION_STEP_TITLE_PROPS}
              >
                {t("NUTRITION_REGISTER_LBL_TITLE")}
              </h2>
              <p className="section-sub">
                {t("NUTRITION_REGISTER_DESC_SUBTITLE")}
              </p>

              <div className="form-row">
                <div className="form-group">
                  <label className="form-label" htmlFor="firstName">
                    {t("FIRST_NAME")}{" "}
                    <RegistrationRequiredMark />
                  </label>
                  <input
                    type="text"
                    id="firstName"
                    name="firstName"
                    placeholder={t("NUTRITION_REGISTER_PLACEHOLDER_FIRST_NAME")}
                    value={values.firstName}
                    onChange={handleChange}
                    onBlur={handleBlur}
                    autoComplete="given-name"
                    {...fieldControlProps("firstName", "form-input", {
                      required: true,
                    })}
                  />
                  {showError("firstName")}
                </div>
                <div className="form-group">
                  <label className="form-label" htmlFor="lastName">
                    {t("LAST_NAME")}{" "}
                    <RegistrationRequiredMark />
                  </label>
                  <input
                    type="text"
                    id="lastName"
                    name="lastName"
                    placeholder={t("NUTRITION_REGISTER_PLACEHOLDER_LAST_NAME")}
                    value={values.lastName}
                    onChange={handleChange}
                    onBlur={handleBlur}
                    autoComplete="family-name"
                    {...fieldControlProps("lastName", "form-input", {
                      required: true,
                    })}
                  />
                  {showError("lastName")}
                </div>
              </div>

              <div className="form-group">
                <label className="form-label" htmlFor="preferredName">
                  {t("PREFERRED_NAME")}
                </label>
                <input
                  type="text"
                  id="preferredName"
                  name="preferredName"
                  placeholder={t("NUTRITION_REGISTER_PLACEHOLDER_PREFERRED_NAME")}
                  value={values.preferredName}
                  onChange={handleChange}
                  onBlur={handleBlur}
                  {...fieldControlProps("preferredName", "form-input")}
                />
                <div className="form-hint">
                  {t("NUTRITION_REGISTER_HINT_PREFERRED_NAME")}
                </div>
                {showError("preferredName")}
              </div>

              <div className="form-group">
                <label className="form-label" htmlFor="email">
                  {t("NUTRITION_COMMON_LBL_EMAIL_ADDRESS")}{" "}
                  <RegistrationRequiredMark />
                </label>
                <input
                  type="email"
                  id="email"
                  name="email"
                  placeholder={t("NUTRITION_REGISTER_PLACEHOLDER_EMAIL")}
                  value={values.email}
                  onChange={handleChange}
                  onBlur={handleBlur}
                  autoComplete="email"
                  {...emailControlProps}
                  className={clsx(
                    emailControlProps.className,
                    emailHasCheckError && "form-input--invalid"
                  )}
                  aria-invalid={
                    emailControlProps["aria-invalid"] || emailHasCheckError
                      ? true
                      : undefined
                  }
                />
                {showError("email")}
                {emailHasCheckError && (
                  <RegistrationFieldError id={emailCheckErrorId}>
                    {emailCheckMessage}
                  </RegistrationFieldError>
                )}
                {emailHasCheckInfo && (
                  <div id={emailCheckInfoId} className="form-hint">
                    {emailCheckMessage}
                  </div>
                )}
              </div>

              <div className="form-group reg-code-row">
                <label className="form-label" htmlFor="registrationCode">
                  {t("REGISTRATION_CODE")}{" "}
                  <RegistrationRequiredMark />
                </label>
                <input
                  type="text"
                  id="registrationCode"
                  name="registrationCode"
                  placeholder={t("NUTRITION_REGISTER_PLACEHOLDER_REG_CODE")}
                  value={values.registrationCode}
                  onChange={handleRegistrationCodeChange}
                  onBlur={handleBlur}
                  disabled={registrationCodeDisabled}
                  {...fieldControlProps("registrationCode", "form-input uppercase", {
                    required: true,
                  })}
                />
                {registrationCodeDisabled && (
                  <button
                    type="button"
                    className="reg-code-close"
                    onClick={closeRegistrationCode}
                    aria-label={t("NUTRITION_REGISTER_ARIA_CLEAR_REG_CODE", {
                      defaultValue: "Clear registration code",
                    })}
                  >
                    X
                  </button>
                )}
                <div className="form-hint">
                  {t("NUTRITION_REGISTER_HINT_REG_CODE + …_BTN_NO_CODE")}{" "}
                  {!registrationCodeDisabled && (
                    <>
                      {codeLoading ? (
                        <Loader height={20} width={20} aria-hidden />
                      ) : (
                        <button
                          type="button"
                          className="form-hint-link"
                          onClick={getCode}
                        >
                          {t("DONT_HAVE_CODE")}
                        </button>
                      )}
                    </>
                  )}
                </div>
                {showError("registrationCode")}
              </div>

              <div className="form-row">
                <div className="form-group">
                  <label className="form-label" htmlFor="reg-dob">
                    {t("DATE_OF_BIRTH")}{" "}
                    <RegistrationRequiredMark />
                  </label>
                  <RegistrationDobField
                    id="reg-dob"
                    name="dob"
                    value={values.dob}
                    onChange={(formatted, { touched }) => {
                      if (touched) {
                        setFieldTouched("dob", true);
                      }
                      setFieldValue("dob", formatted, touched);
                    }}
                    onBlur={() => setFieldTouched("dob", true, true)}
                    {...fieldControlProps("dob", undefined, {
                      required: true,
                    })}
                  />
                  <div className="form-hint">
                    {t("NUTRITION_REGISTER_HINT_DOB_FORMAT", {
                      defaultValue: "Use MM/DD/YYYY",
                    })}
                  </div>
                  {showError("dob")}
                </div>
                <div className="form-group">
                  <label className="form-label" htmlFor="reg-zip">
                    {t("ZIP_CODE")}{" "}
                    <RegistrationRequiredMark />
                  </label>
                  <input
                    type="text"
                    id="reg-zip"
                    name="zipCode"
                    placeholder={t("NUTRITION_REGISTER_PLACEHOLDER_ZIP")}
                    maxLength={5}
                    inputMode="numeric"
                    value={values.zipCode}
                    onChange={handleZipCodeChange}
                    onBlur={handleBlur}
                    {...fieldControlProps("zipCode", "form-input", {
                      required: true,
                    })}
                  />
                  {showError("zipCode")}
                </div>
              </div>

              <div className="form-group">
                <label className="form-label" htmlFor="reg-password">
                  {t("CREATE_PASSWORD")}{" "}
                  <RegistrationRequiredMark />
                </label>
                <div className="password-input-wrap">
                  <input
                    type={showPassword ? "text" : "password"}
                    id="reg-password"
                    name="password"
                    placeholder={t("NUTRITION_REGISTER_PLACEHOLDER_PASSWORD")}
                    autoComplete="new-password"
                    value={values.password}
                    onChange={handleChange}
                    onBlur={handleBlur}
                    {...fieldControlProps("password", "form-input", {
                      required: true,
                    })}
                  />
                  <button
                    type="button"
                    className="password-toggle-btn"
                    onClick={() => setShowPassword((visible) => !visible)}
                    aria-label={
                      showPassword
                        ? t("NUTRITION_REGISTER_ARIA_HIDE_PASSWORD")
                        : t("NUTRITION_REGISTER_ARIA_SHOW_PASSWORD")
                    }
                    aria-pressed={showPassword}
                  >
                    <PasswordVisibilityIcon visible={showPassword} />
                  </button>
                </div>
                <div className="form-hint">
                  {t("NUTRITION_REGISTER_HINT_PASSWORD", {
                    defaultValue:
                      "Use at least 15 characters, including upper and lowercase letters, a number, and a special character.",
                  })}
                </div>
                {showError("password")}
              </div>

              <div className="form-group">
                <label className="form-label" htmlFor="reg-confirm-password">
                  {t("CONFIRM_PASSWORD")}{" "}
                  <RegistrationRequiredMark />
                </label>
                <div className="password-input-wrap">
                  <input
                    type={showConfirmPassword ? "text" : "password"}
                    id="reg-confirm-password"
                    name="confirmPassword"
                    placeholder={t("NUTRITION_REGISTER_PLACEHOLDER_CONFIRM_PASSWORD")}
                    autoComplete="new-password"
                    value={values.confirmPassword}
                    onChange={handleChange}
                    onBlur={handleBlur}
                    {...fieldControlProps("confirmPassword", "form-input", {
                      required: true,
                    })}
                  />
                  <button
                    type="button"
                    className="password-toggle-btn"
                    onClick={() =>
                      setShowConfirmPassword((visible) => !visible)
                    }
                    aria-label={
                      showConfirmPassword
                        ? t("NUTRITION_REGISTER_ARIA_HIDE_CONFIRM_PASSWORD")
                        : t("NUTRITION_REGISTER_ARIA_SHOW_CONFIRM_PASSWORD")
                    }
                    aria-pressed={showConfirmPassword}
                  >
                    <PasswordVisibilityIcon visible={showConfirmPassword} />
                  </button>
                </div>
                {showError("confirmPassword")}
              </div>

              <div className={clsx("why-box", whyBoxOpen && "open")}>
                <button
                  type="button"
                  className="why-toggle"
                  aria-expanded={whyBoxOpen}
                  aria-controls="registration-why-body"
                  onClick={() => setWhyBoxOpen((open) => !open)}
                >
                  <svg
                    width="14"
                    height="14"
                    viewBox="0 0 24 24"
                    fill="none"
                    stroke="currentColor"
                    strokeWidth="2.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    aria-hidden
                  >
                    <circle cx="12" cy="12" r="10" />
                    <line x1="12" y1="8" x2="12" y2="12" />
                    <line x1="12" y1="16" x2="12.01" y2="16" />
                  </svg>
                  {t("NUTRITION_REGISTER_LBL_WHY_NEED")}
                </button>
                <div
                  className="why-body"
                  id="registration-why-body"
                  hidden={!whyBoxOpen}
                >
                  {t("NUTRITION_REGISTER_DESC_WHY_NEED")}
                </div>
              </div>

              <div className="divider" />

              <div className="field-group-label" id="registration-category-label">
                {t("CATEGORY_IMP_LABEL")}{" "}
                <RegistrationRequiredMark />
              </div>
              <p className="field-group-intro">
                {t("NUTRITION_REGISTER_DESC_GOALS")}
              </p>

              <div
                className="knowledge-options"
                role="radiogroup"
                aria-labelledby="registration-category-label"
                aria-required="true"
                aria-invalid={
                  isRegistrationFieldInvalid(
                    errors,
                    touched,
                    submitCount,
                    "categoryId"
                  ) || undefined
                }
                aria-describedby={
                  isRegistrationFieldInvalid(
                    errors,
                    touched,
                    submitCount,
                    "categoryId"
                  )
                    ? getRegistrationFieldErrorId("categoryId")
                    : undefined
                }
                onKeyDown={handleCategoryKeyDown}
              >
                {categoriesLoading ? (
                  <div className="form-hint">
                    <Loader height={20} width={20} aria-hidden />
                  </div>
                ) : (
                  knowledgeOptions.map((option, index) => (
                    <button
                      key={option.id}
                      type="button"
                      role="radio"
                      className={clsx(
                        "know-opt",
                        values.categoryId === option.id && "selected"
                      )}
                      aria-checked={values.categoryId === option.id}
                      tabIndex={getRovingTabIndex(
                        values.categoryId === option.id,
                        index === 0,
                        Boolean(values.categoryId)
                      )}
                      onClick={() => handleCategorySelect(option.id)}
                    >
                      <div className="know-opt-dot">
                        {values.categoryId === option.id && (
                          <RegistrationSelectedCheck />
                        )}
                      </div>
                      <div>
                        <div className="know-opt-title">{option.title}</div>
                        <div className="know-opt-desc">{option.description}</div>
                      </div>
                    </button>
                  ))
                )}
              </div>
              {showError("categoryId")}

              <div className="terms-agreement">
                <input
                  id="accepted-terms"
                  name="acceptedTerms"
                  type="checkbox"
                  className="terms-agreement-checkbox"
                  checked={values.acceptedTerms}
                  onChange={(event) =>
                    setFieldValue("acceptedTerms", event.target.checked, true)
                  }
                  onKeyDown={(event) => {
                    if (event.key !== "Enter" && event.key !== " ") {
                      return;
                    }
                    event.preventDefault();
                    setFieldValue("acceptedTerms", !values.acceptedTerms, true);
                    setFieldTouched("acceptedTerms", true, false);
                  }}
                  onBlur={handleBlur}
                  aria-required="true"
                  aria-invalid={
                    isRegistrationFieldInvalid(
                      errors,
                      touched,
                      submitCount,
                      "acceptedTerms"
                    ) || undefined
                  }
                  aria-describedby={
                    isRegistrationFieldInvalid(
                      errors,
                      touched,
                      submitCount,
                      "acceptedTerms"
                    )
                      ? getRegistrationFieldErrorId("acceptedTerms")
                      : undefined
                  }
                />
                <p className="terms-agreement-text">
                  <label
                    className="terms-agreement-agree"
                    htmlFor="accepted-terms"
                  >
                    {t("REGISTRATION_LABEL_SIGNING_AGREE")}{" "}
                    <RegistrationRequiredMark />
                  </label>{" "}
                  <a
                    className="terms-link"
                    href="/static-page?type=terms"
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    {t("TERMS_AND_CONDITION")}
                  </a>
                  ,{" "}
                  <a
                    className="terms-link"
                    href="/static-page?type=privacy"
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    {t("PRIVACY_POLICY")}
                  </a>
                  ,{" "}
                  <a
                    className="terms-link"
                    href="/static-page?type=hippa"
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    {t("HIPPA_POLICY")}
                  </a>{" "}
                  {t("AND")}{" "}
                  <a
                    className="terms-link"
                    href="/static-page?type=payment"
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    Husk {t("PAYMENT_POLICY")}
                  </a>
                  .
                </p>
              </div>
              {showError("acceptedTerms")}

              <button
                type="submit"
                className="continue-btn"
                disabled={isSubmitting || isEmailCheckPending}
              >
                {t("MORE_CHANGE_LANGUAGE_BTN_CONTINUE")}
                <RegistrationContinueArrow />
              </button>
            </form>
          </div>
        </div>
      </RegistrationLayout>
    </RegisterWrapper>
  );
};

export default compose(
  withRouter,
  enhancer,
  connect(null, { login })
)(Register);
